/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Loader, Header, Container, Segment, Message } from 'semantic-ui-react';
import { setRoom, setPlayer } from '../../actions';
import { useDispatch } from 'react-redux';

export default function WaitingRoom() {
    const roomCode = Math.floor(Math.random() * 100);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setRoom(roomCode));
        dispatch(setPlayer(1));
    }, []);

    return (
        <Container>
            <Segment inverted color='brown' secondary raised>
                <Message info>
                    <Header as='h2'>A játék szobaszáma: {roomCode}</Header>
                    <Loader active inline>
                        Várakozás a másik játékosra...
                    </Loader>
                </Message>
            </Segment>

            <NavLink exact to='/' className='left aligned ui button'>
                <i className='left arrow icon'></i>VISSZA
            </NavLink>
        </Container>
    );
}
